import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDurationba1nlt78o6vu as toDuration,
  Duration__toString_impl_8d916b11f1kpclwmkpg as Duration__toString_impl_8d916b,
  Duration__hashCode_impl_u4exz629donm5f9ouki as Duration__hashCode_impl_u4exz6,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Reactive1jy75v4li6ldv as Reactive,
  Listenable3m4zqvjcbvczy as Listenable,
  beginUse146s8dwmfk72s as beginUse,
  MutableReactive2qdhhyljdknhy as MutableReactive,
} from '../core/coreInterfaces.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { delay1diib1rb84y4j as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../core/AppScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function debounceWrite(_this__u8e3s4, duration) {
  return new (debounceWrite$1())(_this__u8e3s4, duration);
}
function debounce(_this__u8e3s4, timeMs) {
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(timeMs, DurationUnit_MILLISECONDS_getInstance());
  return new (DebounceReactive())(_this__u8e3s4, tmp$ret$0);
}
function debounce_0(_this__u8e3s4, duration) {
  return new (DebounceReactive())(_this__u8e3s4, duration);
}
var DebounceReactiveClass;
function DebounceReactive() {
  if (DebounceReactiveClass === VOID) {
    class $ {
      constructor(source, duration) {
        this.xaq_1 = new (DebounceListenable())(source, duration);
        this.yaq_1 = source;
        this.zaq_1 = duration;
      }
      qah() {
        return this.yaq_1.qah();
      }
      toString() {
        return 'DebounceReactive(source=' + toString(this.yaq_1) + ', duration=' + Duration__toString_impl_8d916b(this.zaq_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.yaq_1);
        result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.zaq_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DebounceReactive()))
          return false;
        if (!equals(this.yaq_1, other.yaq_1))
          return false;
        if (!(this.zaq_1 === other.zaq_1))
          return false;
        return true;
      }
      tah(listener) {
        return this.xaq_1.tah(listener);
      }
      iaj() {
        return this.xaq_1.iaj();
      }
    }
    initMetadataForClass($, 'DebounceReactive', VOID, VOID, [Reactive(), Listenable()]);
    DebounceReactiveClass = $;
  }
  return DebounceReactiveClass;
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = delay($this.car_1.bar_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if ($this.dar_1 === $this.ear_1._v)
    $this.far_1();
  return Unit_instance;
}
var DebounceListenable$addListener$lambda$slambdaClass;
function DebounceListenable$addListener$lambda$slambda() {
  if (DebounceListenable$addListener$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $num, $changeCount, $listener) {
        this.car_1 = this$0;
        this.dar_1 = $num;
        this.ear_1 = $changeCount;
        this.far_1 = $listener;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DebounceListenable$addListener$lambda$slambdaClass = $;
  }
  return DebounceListenable$addListener$lambda$slambdaClass;
}
function DebounceListenable$addListener$lambda$slambda_0(this$0, $num, $changeCount, $listener) {
  var i = new (DebounceListenable$addListener$lambda$slambda())(this$0, $num, $changeCount, $listener);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var DebounceListenableClass;
function DebounceListenable() {
  if (DebounceListenableClass === VOID) {
    class $ {
      constructor(source, duration) {
        this.aar_1 = source;
        this.bar_1 = duration;
      }
      tah(listener) {
        var changeCount = {_v: 0};
        return this.aar_1.tah(() => {
          changeCount._v = changeCount._v + 1 | 0;
          var num = changeCount._v;
          var tmp = get_AppScope();
          launch(tmp, VOID, VOID, DebounceListenable$addListener$lambda$slambda_0(this, num, changeCount, listener));
          return Unit_instance;
        });
      }
      toString() {
        return 'DebounceListenable(source=' + toString(this.aar_1) + ', duration=' + Duration__toString_impl_8d916b(this.bar_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.aar_1);
        result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.bar_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DebounceListenable()))
          return false;
        if (!equals(this.aar_1, other.aar_1))
          return false;
        if (!(this.bar_1 === other.bar_1))
          return false;
        return true;
      }
    }
    protoOf($).iaj = beginUse;
    initMetadataForClass($, 'DebounceListenable', VOID, VOID, [Listenable()]);
    DebounceListenableClass = $;
  }
  return DebounceListenableClass;
}
function *_generator_set__cb7isu($this, value, $completion) {
  $this.har_1 = $this.har_1 + 1 | 0;
  var mine = $this.har_1;
  var tmp = delay($this.jar_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (mine === $this.har_1) {
    var tmp_0 = $this.iar_1.gah(value, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
var debounceWrite$1Class;
function debounceWrite$1() {
  if (debounceWrite$1Class === VOID) {
    class $ {
      constructor($this_debounceWrite, $duration) {
        this.iar_1 = $this_debounceWrite;
        this.jar_1 = $duration;
        this.gar_1 = $this_debounceWrite;
        this.har_1 = 0;
      }
      gah(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_set__cb7isu.bind(VOID, this, value), $completion);
      }
      tak(get, set) {
        return this.gar_1.tak(get, set);
      }
      bak(get, modify) {
        return this.gar_1.bak(get, modify);
      }
      qah() {
        return this.gar_1.qah();
      }
      tah(listener) {
        return this.gar_1.tah(listener);
      }
      iaj() {
        return this.gar_1.iaj();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactive()], [1]);
    debounceWrite$1Class = $;
  }
  return debounceWrite$1Class;
}
//region block: exports
export {
  debounceWrite as debounceWritek53gh4jhz3o8,
  debounce_0 as debounce302w6e33401uo,
  debounce as debounce3uffs71hj1o26,
};
//endregion

//# sourceMappingURL=debounce.mjs.map
